// @ts-check

import ResetGridLink from '~/components/Shared/DataGrid/ResetGridLink';
import { useTemplateDataGridContext } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.context';
import { DEFAULT_SORT_MODEL, EventNames } from '~/components/Forms/TemplateDataGrid/TemplateDataGrid.utils';

export default function ResetTemplateGridLink() {
    const { settings } = useTemplateDataGridContext();

    return (
        <ResetGridLink
            settings={settings}
            resetTableEventName={EventNames.RESET_TABLE}
            defaultSortModel={DEFAULT_SORT_MODEL}            
        />
    );
} 